<template>
  <div style="height: calc(100vh - 70px)">
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div v-if="!loading">
      <div style="height: calc(100vh - 70px); background-color: #ffffff">
        <div class="navbar w-100 nav-main" style="background-color: #23409a; color: white">
          <h3 class="w-100 text-center my-3" style="font-size: 20px;">จัดการข้อมูล</h3>
        </div>
        <div v-if="userData && userData.cardnumber" class="session-with-nav">
          <!-- <div class="px-3" v-if="!hasEtaxBill" style="margin-top: 20px">
            <v-layout align-center class="px-3 py-4" style="background: #f2f2f2; border-radius: 10px">
              <v-flex class="pr-2 caption">
                <strong> คุณยังไม่ได้ลงทะเบียนรับ E-Tax </strong>
                <div style="color: #817f7f">สำหรับรับใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิกส์ผ่านไลน์</div>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" large small style="color: white; min-width: 50%" rounded :href="linkToEtaxBill">กดเปิดใช้งาน</v-btn>
              </v-flex>
            </v-layout>
          </div>
          <div class="px-3" v-else style="margin-top: 20px">
            <v-layout align-center class="px-3 py-4" style="background: #f2f2f2; border-radius: 10px">
              <v-flex class="pr-2 caption">
                <strong> ลงทะเบียนรับ E-Tax </strong>
                <div style="color: #817f7f">สำหรับรับใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิกส์ผ่านไลน์</div>
              </v-flex>
              <v-flex shrink>
                <v-btn color="#5BCF00" large small style="color: white; min-width: 50%" rounded readonly>เปิดใช้งาน</v-btn>
              </v-flex>
            </v-layout>
          </div> -->
          <v-layout class="p-2" nowrap>
            <v-avatar class="border-avatar" width="50px" height="50px">
              <img :src="img" />
            </v-avatar>
            <div style="width: max-content; margin: auto 18px">
              <span>{{ profile.displayName }}</span>
            </div>
          </v-layout>
          <div class="pl-3 text-gray">ผลิตภัณฑ์ของคุณ</div>

          <div class="divider"></div>

          <div>
            <v-layout row justify-space-between class="row-menu m-0">
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/Motorcycle.svg"
                  alt="title-lone"
                />บัญชีสินเชื่อเช่าซื้อ
              </div>
              <div
                @click="showContact = !showContact"
                class="text-primary-2 p-0"
                :style="
                  `width: max-content; cursor:pointer;${
                    showContact ? 'transform: rotate(-90deg)' : ''
                  }`
                "
              >
                <img style="height:24px" src="../assets/profile-new/side.png" alt="side" />
              </div>
            </v-layout>
            <div v-if="showContact == true">
              <div class="ele-shadow"></div>
              <template v-for="(item, index) in showNcapData">
                <v-layout
                  @click="
                    $store.dispatch('setContact', item)
                    $store.dispatch('setContactSource', 'ncap')
                    selectData = item
                    show = true
                  "
                  :key="`contact-list-${index}`"
                  row
                  justify-space-between
                  class="row-menu row-menu-child m-0"
                >
                  <div class="pl-3 text-primary-2" style="width: max-content">
                    เลขที่สัญญา : {{ item.agreementNo }}
                  </div>
                  <div class="text-primary-2" style="width: max-content">></div>
                </v-layout>
                <div v-if="index != showNcapData.length - 1" class="divider-white"></div>
              </template>
            </div>
          </div>

          <div>
            <v-layout row justify-space-between class="row-menu m-0">
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/titleloan.svg"
                  alt="title-lone"
                />บัญชีสินเชื่อจำนำเล่มทะเบียน
              </div>
              <div
                @click="shownMnyContact = !shownMnyContact"
                class="text-primary-2 p-0"
                :style="
                  `width: max-content; cursor:pointer;${
                    shownMnyContact ? 'transform: rotate(-90deg)' : ''
                  }`
                "
              >
                <img style="height:24px" src="../assets/profile-new/side.png" alt="side" />
              </div>
            </v-layout>
            <div v-if="shownMnyContact == true">
              <div class="ele-shadow"></div>
              <template v-for="(item, index) in showNmnyData">
                <v-layout
                  @click="
                    $store.dispatch('setContact', item)
                    $store.dispatch('setContactSource', 'nmny')
                    selectData = item
                    show = true
                  "
                  :key="`contact-list-${index}`"
                  row
                  justify-space-between
                  class="row-menu row-menu-child m-0"
                >
                  <div class="pl-3 text-primary-2" style="width: max-content">
                    เลขที่สัญญา : {{ item.agreementNo }}
                  </div>
                  <div class="text-primary-2" style="width: max-content">></div>
                </v-layout>
                <div v-if="index != shownMnyContact.length - 1" class="divider-white"></div>
              </template>
            </div>
          </div>

          <div class="divider"></div>

          <div class="mt-5">
            <div class="mt-6 pl-3 text-gray">การรับเอกสารอิเล็กทรอนิกส์ ผ่านช่องทางไลน์</div>
            <div class="divider"></div>
          </div>

          <div>
            <v-layout row justify-space-between class="row-menu m-0">
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/invoice.svg"
                  alt="ncb"
                />ใบแจ้งหนี้ ใบเสร็จ ใบกำกับภาษี
              </div>
              <div
                @click="showEtax = !showEtax"
                class="text-primary-2 p-0"
                :style="
                  `width: max-content; cursor:pointer;${
                    showEtax ? 'transform: rotate(-90deg)' : ''
                  }`
                "
              >
                <img style="height:24px" src="../assets/profile-new/side.png" alt="side" />
              </div>
            </v-layout>
            <div v-if="showEtax == true">
              <div class="ele-shadow"></div>

              <v-layout row justify-space-between class="row-menu row-menu-child m-0">
                <div class="pl-3 text-primary-2 after-account" style="width: max-content">
                  บริษัท เน็คซ์ แคปปิตอล
                </div>
                <div
                  @click="
                    openflowConsend(
                      nextCapConsent &&
                        nextCapConsent['Consent-E-TAX'] &&
                        nextCapConsent['Consent-E-TAX'].answer &&
                        nextCapConsent['Consent-E-TAX'].answer === 'Y'
                        ? nextCapConsent['Consent-E-TAX']
                        : null
                    )
                  "
                  class="text-primary-2 p-0"
                  style="width: max-content"
                >
                  <toggle-button
                    color="#23409a"
                    :sync="true"
                    :value="
                      nextCapConsent &&
                        nextCapConsent['Consent-E-TAX'] &&
                        nextCapConsent['Consent-E-TAX'].answer &&
                        nextCapConsent['Consent-E-TAX'].answer === 'Y'
                    "
                  />
                </div>
              </v-layout>
              <div class="divider-white"></div>
              <v-layout row justify-space-between class="row-menu row-menu-child m-0">
                <div class="pl-3 text-primary-2 after-account" style="width: max-content">
                  บริษัท เน็คซ์ มันนี่
                </div>
                <div
                  class="text-primary-2 p-0"
                  style="width: max-content"
                  @click="
                    openflowConsend(
                      nextMoneyConsent &&
                        nextMoneyConsent['Consent-E-Bill'] &&
                        nextMoneyConsent['Consent-E-Bill'].answer &&
                        nextMoneyConsent['Consent-E-Bill'].answer === 'Y'
                        ? nextMoneyConsent['Consent-E-Bill']
                        : null,
                      'nmny'
                    )
                  "
                >
                  <toggle-button
                    color="#23409a"
                    :sync="true"
                    :value="
                      nextMoneyConsent &&
                        nextMoneyConsent['Consent-E-Bill'] &&
                        nextMoneyConsent['Consent-E-Bill'].answer &&
                        nextMoneyConsent['Consent-E-Bill'].answer === 'Y'
                    "
                  />
                </div>
              </v-layout>
            </div>
          </div>
          <div class="divider"></div>
          <div>
            <v-layout row justify-space-between class="row-menu m-0" nowrap>
              <div
                class="p-0 text-primary-2"
                style="width: max-content; color: black;max-width: calc(100% - 24px);"
              >
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/NCBconsent.svg"
                  alt="ncb"
                />หนังสือแจ้งข้อมูลให้บริษัทข้อมูลเครดิตแห่งชาติ
              </div>
              <div
                @click="showNcb = !showNcb"
                class="text-primary-2 p-0"
                :style="
                  `height:24px;width:24px; cursor:pointer;${
                    showNcb ? 'transform: rotate(-90deg)' : ''
                  }`
                "
              >
                <img
                  style="height:24px;width:24px"
                  src="../assets/profile-new/side.png"
                  alt="side"
                />
              </div>
            </v-layout>
            <div v-if="showNcb == true">
              <div class="ele-shadow"></div>
              <v-layout row justify-space-between class="row-menu row-menu-child m-0">
                <div class="pl-3 text-primary-2 after-account" style="width: max-content">
                  บริษัท เน็คซ์ แคปปิตอล
                </div>
                <div
                  @click="
                    openflowConsend(
                      nextCapConsent &&
                        nextCapConsent['Consent_eNCBLetter'] &&
                        nextCapConsent['Consent_eNCBLetter'].answer &&
                        nextCapConsent['Consent_eNCBLetter'].answer === 'Y'
                        ? nextCapConsent['Consent_eNCBLetter']
                        : null
                    )
                  "
                  class="text-primary-2 p-0"
                  style="width: max-content"
                >
                  <toggle-button
                    :sync="true"
                    color="#23409a"
                    :value="
                      nextCapConsent &&
                        nextCapConsent['Consent_eNCBLetter'] &&
                        nextCapConsent['Consent_eNCBLetter'].answer &&
                        nextCapConsent['Consent_eNCBLetter'].answer === 'Y'
                    "
                  />
                </div>
              </v-layout>
              <!-- <div class="divider-white"></div>
              <v-layout row justify-space-between class="row-menu row-menu-child m-0">
                <div class="pl-3 text-primary-2 after-account" style="width: max-content">
                  บริษัท เน็คซ์ มันนี่
                </div>
                <div
                  @click="
                    openflowConsend(
                      nextMoneyConsent &&
                        nextMoneyConsent['Consent_eNCBLetter'] &&
                        nextMoneyConsent['Consent_eNCBLetter'].answer &&
                        nextMoneyConsent['Consent_eNCBLetter'].answer === 'Y'
                        ? nextMoneyConsent['Consent_eNCBLetter']
                        : null,
                      'nmny'
                    )
                  "
                  class="text-primary-2 p-0"
                  style="width: max-content"
                >
                  <toggle-button
                    :sync="true"
                    color="#23409a"
                    :value="
                      nextMoneyConsent &&
                        nextMoneyConsent['Consent_eNCBLetter'] &&
                        nextMoneyConsent['Consent_eNCBLetter'].answer &&
                        nextMoneyConsent['Consent_eNCBLetter'].answer === 'Y'
                    "
                  />
                </div>
              </v-layout> -->
            </div>
          </div>
          <div class="divider"></div>
          <div class="mt-5">
            <div class="mt-6 pl-3 text-gray">ข้อกำหนดและความเป็นส่วนตัว</div>
            <div class="divider"></div>
            <v-layout row justify-space-between class="row-menu m-0">
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/consentManagement2.svg"
                  alt="title-lone"
                />การจัดการความยินยอม Next Capital
              </div>
              <div
                @click="showMktPdpa = true"
                class="text-primary-2 p-0"
                style="width: max-content; cursor:pointer;"
              >
                <img style="height:24px" src="../assets/profile-new/side.png" alt="side" />
              </div>
            </v-layout>
            <v-layout row justify-space-between class="row-menu m-0">
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/consentManagement2.svg"
                  alt="title-lone"
                />การจัดการความยินยอม Next Money
              </div>
              <div
                @click="showNmnyMktPdpa = true"
                class="text-primary-2 p-0"
                style="width: max-content; cursor:pointer;"
              >
                <img style="height:24px" src="../assets/profile-new/side.png" alt="side" />
              </div>
            </v-layout>
            <div class="divider"></div>
            <v-layout row justify-space-between class="row-menu m-0">
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <img
                  style="height: 24px;"
                  class="pr-2"
                  src="../assets/icon/TermCondition.svg"
                  alt="title-lone"
                />ข้อกำหนดและเงื่อนไข
              </div>
              <div
                @click="showTerm = true"
                class="text-primary-2 p-0"
                style="width: max-content; cursor:pointer;"
              >
                <img style="height:24px" src="../assets/profile-new/side.png" alt="side" />
              </div>
            </v-layout>
          </div>
          <div class="divider"></div>

          <div class="mt-5">
            <div class="mt-6 pl-3 text-gray">อื่นๆ</div>
            <div class="divider"></div>
            <v-layout
              @click="cancelRegis"
              row
              justify-space-between
              class="row-menu m-0"
              style="cursor: pointer"
            >
              <div class="pl-0 text-primary-2" style="width: max-content; color: black">
                <v-icon class="text-blue pr-2">mdi mdi-trash-can-outline</v-icon>ยกเลิกใช้งาน Next
                Connect
              </div>
            </v-layout>
            <div class="divider"></div>
            <div class="mt-3 pl-3 text-gray" style="font-size:14px">
              หากยกเลิกบริการ Next Connect จะไม่สามารถรับข้อมูลและการ
              สอบถามข้อมูลสินเชื่อผ่านช่องทางนี้ได้
            </div>
          </div>
        </div>

        <div v-else style="margin-top: 100px">
          <div class="text-center mt-7">กรุณาลงทะเบียนก่อนการใช้บริการนี้ครับ</div>
          <div class="flex-all-center mt-5">
            <v-btn
              color="primary"
              large
              style="color: white; min-width: 50%"
              class="main-btn"
              @click="$router.push('/regis')"
              >ลงทะเบียน</v-btn
            >
          </div>
        </div>
      </div>
      <v-dialog
        v-model="show"
        scrollable
        fullscreen
        persistent
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-card class="py-2 px-5">
          <v-toolbar
            dark
            class="position-fixed col-12 pt-0"
            style="height: 56px; top: 0; z-index: 2"
            :color="color"
          >
            <v-btn style="position: absolute;" icon dark @click="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <h4 style="text-align: center;width: 100%;">รายละเอียดยอด</h4>
          </v-toolbar>
          <div style="margin-top: 80px; background-color: white">
            <div class="mb-3 flex-all-center">
              <div>
                <v-img
                  v-if="this.$store.state.sourceSelect == 'nmny'"
                  class="radius-circle"
                  style="width:100px;height:auto"
                  src="@/assets/logo_h2_nm.png"
                ></v-img>
                <v-img
                  v-else
                  class="radius-circle"
                  style="width:100px;height:auto"
                  src="@/assets/logo_h.png"
                ></v-img>
              </div>
            </div>
            <h6
              class="pl-5 text-blue mb-8"
              :style="`color: ${color} !important`"
              v-if="selectData && selectData.model"
            >
              รายละเอียดสัญญาเลขที่ {{ selectData.agreementNo }}
            </h6>
            <ContractTable
              v-if="selectData && selectData.model"
              :showData="selectData"
              :color="color"
            />
            <div class="mb-5 w-100 flex-all-center">
              <v-btn
                @click="$router.push('/paymentgenerate')"
                large
                class="main-btn"
                style="color: white"
                :color="color"
                >ขอบาร์โค้ด/คิวอาร์โค้ดเพื่อชำระเงิน</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog
      v-model="showTerm"
      scrollable
      fullscreen
      persistent
      transition="dialog-bottom-transition"
      style="background-color:white"
    >
      <v-card style="background-color:white">
        <div
          class="navbar nav-regis w-100"
          style="background-color: #23409a; color: white;position: fixed;z-index:101"
        >
          <div
            style="    
        font-size: 20px;
        padding-left: 20px;
        position: absolute;
        z-index: 102;
        width: 100%;
        color: white;
        display: flex;
        justify-content: flex-start;
        align-items: center;"
          >
            <div @click="showTerm = false">
              <v-icon dark style="font-size: 36px">mdi-chevron-left</v-icon>
            </div>
          </div>
          <h3 class="w-100 text-center my-3">ข้อกำหนดและเงื่อนไข</h3>
        </div>
        <term2 :read="true" />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showMktPdpa"
      scrollable
      fullscreen
      persistent
      transition="dialog-bottom-transition"
    >
      <div
        class="navbar nav-regis w-100"
        style="background-color: #23409a; color: white;position: fixed;z-index:101"
      >
        <div
          style="    
        font-size: 20px;
        padding-left: 20px;
        position: absolute;
        z-index: 102;
        width: 100%;
        color: white;
        display: flex;
        justify-content: flex-start;
        align-items: center;"
        >
          <div @click="showMktPdpa = false">
            <v-icon dark style="font-size: 36px">mdi-chevron-left</v-icon>
          </div>
        </div>
        <h3 class="w-100 text-center my-3">ความยินยอม</h3>
      </div>
      <PdpaMkt
        @next="handleUpdateMktPdpa"
        :loadData="true"
        :hideHeader="true"
        :mkt="
          nextCapConsent &&
          nextCapConsent['Consent_PDPA_MKT'] &&
          nextCapConsent['Consent_PDPA_MKT'].answer
            ? nextCapConsent['Consent_PDPA_MKT'].answer
            : null
        "
        :mktPdpa="
          nextCapConsent &&
          nextCapConsent['Consent_PDPA_MKTPDPA'] &&
          nextCapConsent['Consent_PDPA_MKTPDPA'].answer
            ? nextCapConsent['Consent_PDPA_MKTPDPA'].answer
            : null
        "
      />
    </v-dialog>

    <v-dialog
      v-model="showNmnyMktPdpa"
      scrollable
      fullscreen
      persistent
      transition="dialog-bottom-transition"
    >
      <div
        class="navbar nav-regis w-100"
        style="background-color: #007a47; color: white;position: fixed;z-index:101"
      >
        <div
          style="    
        font-size: 20px;
        padding-left: 20px;
        position: absolute;
        z-index: 102;
        width: 100%;
        color: white;
        display: flex;
        justify-content: flex-start;
        align-items: center;"
        >
          <div @click="showNmnyMktPdpa = false">
            <v-icon dark style="font-size: 36px">mdi-chevron-left</v-icon>
          </div>
        </div>
        <h3 class="w-100 text-center my-3">ความยินยอม</h3>
      </div>
      <PdpaMktNextMoney
        @next="handleUpdateMktPdpa"
        :loadData="true"
        :hideHeader="true"
        :mkt="
          nextMoneyConsent &&
          nextMoneyConsent['Consent_PDPA_MKT'] &&
          nextMoneyConsent['Consent_PDPA_MKT'].answer
            ? nextMoneyConsent['Consent_PDPA_MKT'].answer
            : null
        "
        :mktPdpa="
          nextMoneyConsent &&
          nextMoneyConsent['Consent_PDPA_MKTPDPA'] &&
          nextMoneyConsent['Consent_PDPA_MKTPDPA'].answer
            ? nextMoneyConsent['Consent_PDPA_MKTPDPA'].answer
            : null
        "
      />
    </v-dialog>

    <div
      style="    
      position: absolute;
      z-index: 100;
      background: white;
      top: 0px;
      margin-top: -70px;"
      v-if="needConsend"
    >
      <div
        class="navbar nav-regis w-100"
        style="background-color: #23409a; color: white;position: fixed;z-index:101"
      >
        <h3 class="w-100 text-center my-3">ข้อกำหนดและเงื่อนไขการใช้บริการ</h3>
      </div>
      <term2 :read="false" :back="false" @next="needConsend = false" />
    </div>
    <v-dialog v-model="showModel" persistent max-width="500px" transition="dialog-transition">
      <v-card class="p-3 pb-8">
        <div class="text-right">
          <v-btn icon @click="showModel = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="px-3">
          <h4 class="text-primary-2" style="text-align: center;font-weight: bold;">
            ต้องการเปลี่ยนช่องทางในการรับเอกสาร
          </h4>
          <div class="text-primary-2">
            <div style="text-align: center;">กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์</div>
            <div style="text-align: center;">ที่ช่องทางไลน์บัญชี Next Connect</div>
            <div style="text-align: center;">หรือ โทร. 02 342 9699</div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import contractApi from '@/api/contract'
import moment from 'moment'
import ContractTable from '@/components/contractTable.vue'
import term2 from '@/components/regis/term2.vue'
import PdpaMkt from '@/components/regis/PdpaMkt.vue'
import PdpaMktNextMoney from '@/components/regis/PdpaMktNextMoney.vue'
import VueElementLoading from 'vue-element-loading'
import config from '@/config'
import consendApi from '@/api/consend'
import { ToggleButton } from 'vue-js-toggle-button'
import { formatThaiDate } from '@/utils/dateFormat'

export default {
  components: { ContractTable, VueElementLoading, term2, PdpaMkt, PdpaMktNextMoney, ToggleButton },
  data() {
    return {
      showModel: false,
      loading: true,
      loadingMain: true,
      loadingCancel: false,
      show: false,
      selectData: null,
      showNcapData: null,
      showNmnyData: null,
      userData: null,
      hasEtaxBill: false,
      nextCapData: null,
      nextMoneyData: null,
      nextCapConsent: null,
      nextMoneyConsent: null,
      showTerm: false,
      showMktPdpa: false,
      showNmnyMktPdpa: false,
      needConsend: false,
      showContact: true,
      shownMnyContact: true,
      showEtax: true,
      showNcb: true
    }
  },
  mounted() {},
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup()
        }
      }
    }
  },
  methods: {
    handleUpdateMktPdpa() {
      try {
        this.showMktPdpa = false
        this.loading = true
        this.fetchConsend()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async setup() {
      try {
        this.loading = true
        await this.fetchUserData(this.userId)
        await this.fetchContactV2()
        await this.fetchConsend()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
        this.loadingMain = false
      }
    },
    openflowConsend(consendData, source = 'ncap') {
      if (consendData) {
        this.showModel = true
      } else {
        if (source == 'nmny') {
          window.location = this.linkToNMEtaxBill
        } else {
          window.location = this.linkToEtaxBill
        }
      }
    },
    async fetchConsend() {
      // Consent-E-TAX
      // Consent_eNCBLetter
      try {
        const responseConsendList = await consendApi.getUserConsendV2({
          page_id: config.pageid,
          user_id: this.user_id
        })
        if (responseConsendList && responseConsendList.data && responseConsendList.data.data) {
          const dataPool = responseConsendList.data.data
          this.setConsendData(dataPool)
          this.checkConsend(dataPool)
        }
      } catch (error) {}
    },
    checkConsend() {
      if (this.nextCapData && this.nextCapData.consent && this.nextCapData.consent.length) {
        const tcData = this.nextCapData.consent.find(consend => consend.consentType == 'Consent_TC')
        if (
          tcData &&
          tcData.version &&
          tcData.currentVersion &&
          tcData.currentVersion != tcData.version
        ) {
          this.needConsend = true
        }
      }
    },
    setConsendData(dataPool) {
      this.nextCapData = dataPool.find(
        company => company.companyKey == 'NCAP' && company.activeStatus == true
      )
      this.nextMoneyData = dataPool.find(
        company => company.companyKey == 'NMNY' && company.activeStatus == true
      )
      if (this.nextCapData && this.nextCapData.consent && this.nextCapData.consent.length) {
        let objData = {}
        this.nextCapData.consent.forEach(consend => {
          objData[consend.consentType] = consend
        })
        this.nextCapConsent = objData
      }
      if (this.nextMoneyData && this.nextMoneyData.consent && this.nextMoneyData.consent.length) {
        let objData = {}
        this.nextMoneyData.consent.forEach(consend => {
          objData[consend.consentType] = consend
        })
        this.nextMoneyConsent = objData
      }
    },
    async cancelRegis() {
      let result = await this.$swal.fire({
        title: 'ต้องการยกเลิกบริการใช้งาน NEXT CONNECT',
        text:
          'รับใบแจ้งหนี้ ใบเสร็จรับเงิน/ใบกำกับภาษี หนังสือแจ้งข้อมูลประวัติการชำระสินเชื่อที่รายงานบริษัทข้อมูลเครดิตแห่งชาติ จำกัด ในรูปแบบอิเล็กทรอนิกส์ จะถูกจัดส่งให้คุณทางไปรษณีย์ ยกเว้นเอกสารที่ ณ ปัจจุบันมีสถานะรอจัดส่งแล้ว จะยังคงส่งที่บัญชีไลน์นี้',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'ต้องการ',
        cancelButtonText: 'ไม่ต้องการ',
        customClass: {
          header: 'header-class',
          title: 'fs-19',
          content: 'fs-16',
          confirmButton: 'main-btn col-5 m-0 myred',
          cancelButton: 'main-btn col-6 m-0 mysilver',
          actions: 'p-0 w-100 d-flex flex-row justify-content-between'
        }
      })
      if (result.value) {
        this.loadingCancel = true
        let body = {
          userId: this.userId,
          idCard: this.userData.cardnumber,
          pageid: config.pageid,
          etaxebill: this.hasEtaxBill ? 'regis' : 'unregis',
          canceletaxebill: this.hasEtaxBill ? true : false
        }
        let res = await api.unbind(body)
        if (res.responsecode == 204) {
          this.loadingCancel = false
          this.$router.push('unlinkdone')
        } else {
          this.loadingCancel = false
          this.$swal.fire({
            text: 'ยกเลิกบริการไม่สำเร็จ',
            type: 'error'
          })
        }
      }
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId)
        if (res.responsecode == 200 && res.data.id) {
          this.userData = res.data
          this.$store.state.userData = res.data
        } else {
          console.log('error fetch user data')
        }
      }
    },
    async fetchContact() {
      let body = {
        IDCard: this.userData.cardnumber,
        BirthDay: formatThaiDate(this.userData.dob),
        pageid: config.pageid
      }
      let res = await api.getContact(body)
      if (res && res.responsecode == 200) {
        this.showNcapData = res.data
        if (
          this.showNcapData &&
          this.showNcapData.length > 0 &&
          this.showNcapData[0].etaxebill == 'regis'
        ) {
          this.hasEtaxBill = true
        }
      } else {
        // this.$router.push("/regis");
      }
    },
    async fetchContactV2() {
      this.loading = true
      try {
        const configApi = {
          body: {
            page_id: config.pageid,
            id_card: this.userData.cardnumber,
            birth_day: formatThaiDate(this.userData.dob)
          },
          config: {}
        }
        const response = await contractApi.getLoanInfo(configApi)
        this.showNcapData = response?.data?.data?.ncapLoanInfoList
        this.showNmnyData = response?.data?.data?.nmnyLoanInfoList
        if (this.showNcapData?.[0]?.etaxebill == 'regis') {
          this.hasEtaxBill = true
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          text: 'เรียกข้อมูลไม่สำเร็จ'
        })
      } finally {
        this.loading = false
      }
    },
    close() {
      this.$liff.closeWindow()
    }
  },
  computed: {
    color() {
      if (this.$store.state.sourceSelect == 'nmny') {
        return '#007a47'
      }
      return '#23409a'
    },
    linkToEtaxBill() {
      return this.$store.getters.getLinkEtax
    },
    linkToNMEtaxBill() {
      return this.$store.getters.getNMLinkEtax
    },
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    img() {
      return this.$store.state.profile.pictureUrl
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.getters.getUserid
    },
    user_id() {
      return this.$store.state.userid
    }
  }
}
</script>

<style>
.myred {
  background-color: rgb(253, 67, 55) !important;
}
.mysilver {
  background: #f5f5f5 !important;
  color: black !important;
}
.border-avatar {
  border: 4px solid white;
}
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
